import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import ImportarClientesPanel from '../components/ImportarClientesPanel';

const PageContainer = styled.div`
  max-width: 1400px;
`;

const PageHeader = styled.div`
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: ${props => props.theme.fontSizes.sm};
  color: ${props => props.theme.colors.textSecondary};
  text-decoration: none;
  margin-bottom: ${props => props.theme.spacing.sm};

  &:hover { color: ${props => props.theme.colors.primary}; }
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxxl};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0;
`;

const Content = styled.div`
  background: ${props => props.theme.colors.backgroundLight};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: ${props => props.theme.spacing.xl};
  box-shadow: ${props => props.theme.shadows.card};
`;

const ImportarClientes = () => {
  return (
    <PageContainer>
      <PageHeader>
        <BackLink to="/configuracion"><MdArrowBack /> Volver a Configuración</BackLink>
        <Title>Importar Clientes</Title>
      </PageHeader>

      <Content>
        <ImportarClientesPanel />
      </Content>
    </PageContainer>
  );
};

export default ImportarClientes;
